import React from "react";

type PROPS = {};

const TopHeader: React.FC<PROPS> = (props) => {
  return (
    <div className="jhk-header flex justify-between items-center p-4 border border-b">
        <a href={process.env.REACT_APP_TOPPAGE_JDP_STG_URL ?? '/'}>
          <img src={`${process.env.PUBLIC_URL}/trust-linkage-logo.png`} alt="logo" className="w-40" />
        </a>
    </div>
  );
};

export default TopHeader;
